import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import { isGroupedTask } from '../../tasks/tasks.model';

/** Swaps each task's account name for the bank's nickname for that account, where one is set. */
export const getTasksWithNicknames = <T extends MinifiedTask | GroupedTask>(
  tasks: T[],
  dispensaries: { id: string; name: string }[]
): T[] => {
  const namesById = new Map(dispensaries.map((dispensary) => [dispensary.id, dispensary.name]));

  const applyNickname = (task: MinifiedTask): MinifiedTask =>
    task.account
      ? { ...task, account: { ...task.account, name: namesById.get(task.account.id) ?? task.account.name } }
      : task;

  return tasks.map((task) =>
    isGroupedTask(task) ? { ...task, tasks: task.tasks.map(applyNickname) } : applyNickname(task)
  ) as T[];
};
